<template>
  <div class="homen" style="width: 100%;margin: auto;min-height: 480px;padding-top: 0px">
<!--    <div class="col-tital"> <div class="col-tital-main">政 策 <span style="color: #0a76a4">咨 讯</span></div><div class="col-tital-minor">汇集政策热点 详实政策解读</div></div>-->
   <div class="banner">
     <div class="slg"> <p class="slg_title1">招投标专项信用公示服务平台</p>
       <p class="slg_title2">诚信为基共筑未来 贴心服务助力企业发展</p></div>
<!--     <div class="section-banner"></div>-->

   </div>
<!--    <div class="col-con">-->
<!--      <div class="col-con-left">-->
<!--        <img src="../assets/img/news/1740615717520.jpg" style="width: 640px;height: 315px;">-->
<!--      </div>-->
<!--      <div class="col-con-right">-->
<!--        <div class="col-con-left-tital">-->
<!--          <img src="../assets/img/shutiao.png" class="col-con-tital-tiao">-->
<!--          <div class="col-con-left-tital-main">企业动态</div>-->
<!--          <a href="/newslist" target="_blank">-->
<!--            <div class="col-con-left-tital-min">更多></div>-->
<!--          </a>-->
<!--        </div>-->

<!--        <ul>-->
<!--          <li>-->
<!--            <router-link to="/new2024101701" target="_blank">-->
<!--              <div class="col-con-li-title">中国人民银行成立75周年</div><div class="col-con-li-title-r"><el-tag type="warning" size="medium">企业动态</el-tag></div>-->
<!--              <div class="col-com-li-time">发布时间:2024-10-01</div>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <router-link to="/news2024101702" target="_blank">-->
<!--              <div class="col-con-li-title">北京冠捷时速信用管理有限责任公司为信用中国公示第一批可出具信用报告的信用服务机构</div><div class="col-con-li-title-r"><el-tag type="warning" size="medium">企业动态</el-tag></div>-->
<!--              <div class="col-com-li-time">发布时间:2024-10-01</div>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--             <router-link to="/news2024101703" target="_blank">-->
<!--              <div class="col-con-li-title">中国人民银行营业管理部关于公布北京地区完成备案办理的企业征信机构名单的公告</div><div class="col-con-li-title-r"><el-tag type="warning" size="medium">企业动态</el-tag></div>-->
<!--              <div class="col-com-li-time">发布时间:2024-10-01</div>-->
<!--            </router-link>-->
<!--          </li>-->
<!--        </ul>-->

<!--      </div>-->
<!--    </div>-->
    <div class="col-tital">
          <div class="col-tital-main">信用<span style="color: #0a76a4">管理</span></div>    </div>
    <div class="col-con" style="margin-top: 20px;height: 280px">
            <div class="rmyw_list clearfix">
            <div class="remy_item wow fadeInUp" data-wow-delay=".1s" style="visibility: visible;animation-delay: 0.1s;animation-name: fadeInUp;">
                <div class="wimg"><img src="../assets/img/remy1.png" class="pubimg1s"></div>
                <div class="wnry">金融服务</div>
                <div class="wnre">精确评估企业授信额度</div>
<!--                <a href="http://www.guanjiess.com/" target="_blank"><div class="wnrs">立即试用</div></a>-->
            </div>
            <div class="remy_item wow fadeInUp" data-wow-delay=".2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                <div class="wimg"><img src="../assets/img/remy2.png" class="pubimg1s"></div>
                <div class="wnry">信用服务</div>
                <div class="wnre">企业信用状态实时跟踪</div>
<!--                <a href="http://www.guanjiess.com/" target="_blank"><div class="wnrs">立即试用</div></a>-->
            </div>
            <div class="remy_item wow fadeInUp" data-wow-delay=".4s" style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">
                <div class="wimg"><img src="../assets/img/remy4.png" class="pubimg1s"></div>
                <div class="wnry">数据服务</div>
                <div class="wnre">强化信息保护维护信用权益</div>
<!--                <a href="http://www.guanjiess.com/" target="_blank"><div class="wnrs">立即试用</div></a>-->
            </div>
            <div class="remy_item wow fadeInUp" data-wow-delay=".5s" style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInUp;">
                <div class="wimg"><img src="../assets/img/remy5.png" class="pubimg1s"></div>
                <div class="wnry">信用报告</div>
                <div class="wnre">深度挖掘客户信息全方位规避风险</div>
<!--                <a href="http://www.guanjiess.com/" target="_blank"><div class="wnrs">立即试用</div></a>-->
            </div>
        </div>
    </div>
    <div class="col-con" style="width: 100%; max-width: 1215px; margin: auto; margin-top: 20px; margin-bottom: 20px">
      <img src="../assets/202503011026211.png" style="width: 100%; height: auto; max-height: 178px;"/>
    </div>
    <div style="width: auto;background: #f3f3f3;padding-top: 40px">
          <div class="col-tital"> <div class="col-tital-main">优质<span style="color: #0a76a4">服务</span></div></div>
          <div class="col-con" style="margin-top: 20px">
      <div class="Syleader_all clearfix">
            <div class="Syleader_item wow fadeInUp" data-wow-delay=".1s" style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="dimg"><img src="../assets/img/leader1.png" class="pubimg1s"></div>
                <div class="dnr1">企业风险预警</div>
                <div class="dnr2">
                    管理企业信用风险<br>
                    针对投资、借款、赊销企业进行持续跟踪的服务产品
                </div>
            </div>
            <div class="Syleader_item wow fadeInUp" data-wow-delay=".2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                <div class="dimg"><img src="../assets/img/leader2.png" class="pubimg1s"></div>
                <div class="dnr1">城市信用监测</div>
                <div class="dnr2">
                    提升城市信用排名<br>
                    后期利用“信易+”等创新应用加分
                </div>
            </div>
            <div class="Syleader_item wow fadeInUp" data-wow-delay=".3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
                <div class="dimg"><img src="../assets/img/leader3.png" class="pubimg1s"></div>
                <div class="dnr1">信用信息共享</div>
                <div class="dnr2">
                    协助政府相关部门<br>
                    为政府提供公共信用信息共享平台的规划建设、升级改造、运营维护服务
                </div>
            </div>
            <div class="Syleader_item wow fadeInUp" data-wow-delay=".4s" style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">
                <div class="dimg"><img src="../assets/img/leader4.png" class="pubimg1s"></div>
                <div class="dnr1">“信易+”</div>
                <div class="dnr2">
                    运用先进技术和资源<br>
                    定制化的信用产品与信用服务
                </div>
            </div>
            <div class="Syleader_item wow fadeInUp" data-wow-delay=".5s" style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInUp;">
                <div class="dimg"><img src="../assets/img/leader5.png" class="pubimg1s"></div>
                <div class="dnr1">信用报告</div>
                <div class="dnr2">
                    准确合规的多维度信息
                    更规范，让数据更安全
                </div>
            </div>
        </div>
          </div>
            </div>

<!--    <img src="../assets/img/backas.png" height="456" width="2103"/>-->
    <span class="hidden1">
    <div class="col-tital" style="margin-top: 20px">
          <div class="col-tital-main">友情<span style="color: #0a76a4">链接</span></div>    </div>
    <div class="col-con" style="height: 300px;background: #ffffff;">
      <div class="col-yqlj">
        <a href="https://www.miit.gov.cn" target="_blank">
          <img src="../assets/img/y1.png" height="109" width="273">
        </a>
        <a href="https://www.sme.com.cn/" target="_blank">
          <img src="../assets/img/2022logo.png" style="height: 55px;padding-bottom: 21px;">
        </a>
        <a href="http://365trade.com.cn/" target="_blank">
          <img src="../assets/img/y3.png" height="109" width="273">
        </a>
        <a href="https://www.bfhg.com.cn/" target="_blank">
          <img src="../assets/img/y4.png" height="109" width="273">
        </a>
        <a href="https://www.inspur.com/" target="_blank">
          <img src="../assets/img/y5.png" height="109" width="273">
        </a>
        <a href="https://www.spacechina.com/" target="_blank">
          <img src="../assets/img/y6.png" height="109" width="273">
        </a>
        <a href="http://www.xlshuju.cn/" target="_blank">
          <img src="../assets/img/y7.jpg" height="109" width="273">
        </a>
        <a href="http://www.shuzihua.xlshuju.cn/" target="_blank">
          <img src="../assets/img/y8.png" height="109" width="273">
        </a>
      </div>
    </div>
      </span>
<!--    查询版-->
  </div>
</template>

<script>
import { list } from '@/api/news'
import { creditTop } from '@/api/home'
import Pagination from '@/components/Pagination'
export default {
  name: 'Home',
  components: {
    Pagination
  },
  data () {
    return {
      // imgUrl: 'http://192.168.1.92:8800',
      imgUrl: 'https://events.sme.com.cn/api',
      channel: [],
      list: null,
      list2: null,
      listImg: null,
      listCredit: null,
      listLoading: true,
      index: '',
      sortIndex: 0,
      carouselIndex: 0,
      currentPage: 1,
      limit: 10,
      total: 0,
      formInline: {
        eName: '',
        eName1: '',
        eName2: ''
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName1: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName2: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ]
      },
      lv: 1
    }
  },
  created () {
    // this.fetchData()
    // this.fetchData2()
    // this.fetchCredit()
    // this.fetchImg()
  },
  methods: {

    onSubmitxy (formInline) {
      var that = this
      var ename = that.formInline.eName
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/creditSearchAll.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
    },
    onSubmitrz () {
      var that = this
      var ename = that.formInline.eName1
      console.log(that.formInline)
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        console.log(valid)
        if (valid) {
          window.location.href = '/static/rzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmitzz () {
      var that = this
      var ename = that.formInline.eName2
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/zzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    onButton1 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 1
    },
    onButton2 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 2
    },
    onButton3 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 3
    },
    fetchData () {
      list({ currentPage: this.currentPage, channelId: '0', pagenow: this.currentPage, pageSize: 6 }).then(response => {
        if (response.result === 1) {
          this.total = response.data.total
          this.list = response.data.list
          // const list1 = this.list
          // this.list2 = list1
          // console.log(this.list)
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchData2 () {
      list({ currentPage: this.currentPage, channelId: '2', pagenow: this.currentPage, pageSize: 4 }).then(response => {
        if (response.result === 1) {
          this.total = response.data.total
          this.list2 = response.data.list
          console.log(this.listImg)
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchCredit () {
      creditTop().then(response => {
        if (response.result === 1) {
          this.listCredit = response.data
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchImg () {
      list({ currentPage: this.currentPage, channelId: '0', pagenow: this.currentPage, pageSize: 19 }).then(response => {
        if (response.result === 1) {
          this.listImg = response.data.list.splice(0, 3)
        }
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleSizeChange (val) {
      this.limit = val
      this.currentPage = 1
      this.fetchData()
    },
    handleClick (id) {
      window.location.href = '/static/xxgsjg.html' + '?entid=' + id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .slg{
     width: 90%;
  max-width: 1200px;
    margin: auto;
    padding-top: 200px;
  }
  .slg_title1{
    font-size: 3rem;
    color: #d46700;
    margin: 0px 0px 0px 0px;
  }
    .slg_title2{
      margin: 20px 0px 0px 0px;
    font-size: 2rem;
    color: #ffffff;
      position: relative;
    z-index: 3;
  }
    .section-banner {
        float: right;
    top: -448px;
    right: 187px;
    z-index: 2;
  height: 650px;
  width: 650px;
  position: relative;
  transition: left 0.3s linear;
  background: url(" ../assets/img/map1.jpg");
    background-size: cover;
  background-position: left;
  bottom: 0px;
  border-radius: 50%;
  animation: earthRotate 10s linear 0s infinite;
  box-shadow: 0px 0 20px RGBA(255, 255, 255, 0.2), -5px 0px 8px #c3f4ff inset,
    15px 2px 25px #000 inset, -24px -2px 34px #c3f4ff99 inset,
    250px 0px 44px #00000011 inset, 150px 0px 38px #000000aa inset;
}
@keyframes earthRotate {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 400px 0;
  }
}
@keyframes twinkling {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
</style>
<style>
  /*.homen{background: url(../assets/img/dingbak.png) no-repeat center;background-size:100% 100%;}*/
  .el-main{
    padding: 0px !important;
    /*background-color: #f5f5f500;*/

  }
   .listNews{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 28px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444444;
  }
  .listNews1{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 18px;
    font-weight: normal;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #555555;
  }
  .box-title{    width: 100%;
    margin: auto;    border-bottom: 2px solid #e5e5e5;}
  .box-title  strong {
    font-size: 20px ;
    margin-left: 10px;
    margin-bottom: 8px;
    line-height: 26px;
    height: 50px;
    border-bottom: 2px solid #d80026;
    text-indent: 0.5em;
    color: #d80026;

}
  .box-title  strong a{
    color: #d80026;
    text-decoration: none;
    cursor: pointer;
  }
  .recommend4 a{    text-decoration: none;
    cursor: pointer;
  color: #555;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
  .recommend4 li{line-height: 40px;width: 98%;overflow: hidden;text-overflow:ellipsis}
  .recommend3 li:nth-of-type(3n - 2) a, .recommend4 li:nth-of-type(6n - 5) a, .recommend5 li:nth-of-type(5n - 4) a, .recommend6 li:nth-of-type(6n - 5) a, .recommend7 li:nth-of-type(7n - 6) a {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background: none;

}
    .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .searchbar{
    margin: auto;
    width: 800px;
    top: 50%;
  }
  .h1title{
    text-align:center;color: #1065c0;font-size: 30px;font-weight: 700;margin-bottom: 60px
  }
  .abb{
    width: 800px;
    margin: 0px auto 20px;
    text-align: center;

  }
  .rmyw_list {
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  /*justify-content: center;*/
}
  .homen .abb .el-button{
    border:0px !important;
    font-size: 22px !important;
    color: #409eff !important;
    font-weight: bold !important;
  }
    .homen .abb .el-button:hover{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff;
  }
      .homen .abb .el-button:visited{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .abb .el-button:active{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .abb .el-button:focus{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .el-form-item__content {
    margin-left: 0px !important;
  }
.banner {
    background-image: url(../assets/img/bg1.jpg);
    background-size: cover;
    background-position: center;
    height: 560px;
    overflow: hidden;
}
  .bottonbanner{
    background: url(../assets/img/backbanner.png) no-repeat center;background-size:100% 100%;
  }
  .col-tital {
  width: 90%;
  max-width: 1250px;
  margin: auto;
  text-align: left;
  }
.col-tital-main{
  text-align: center;
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 40px;
  font-weight: bold;
  font-family: "微软雅黑 ";
}
.col-tital-minor{
  font-size: 14px;
  font-family: "微软雅黑 Light";
  margin-top: 10px;
  margin-bottom: 40px;
  color: #aaaaaa;
}
  .col-con{
    width: 90%;
    max-width: 1250px;
    margin: auto;
    height: 340px;
    /*margin-top: 10px;*/
  }
  .col-con ul{
    list-style-type: none;
    float: left;
    /*margin-left: -25px;*/
  }
  .col-con li{
    box-sizing: inherit;
    width: 540px;
    line-height: 30px;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px #cccccc dashed;
    margin-bottom: 15px;
  }
      .col-con-left{
    float: left;
      width: 585px;
        margin-right: 15px;
        background: #ffffff;
        padding: 5px;
  }
    .col-con-left-tital{
    float: left;
      width: 575px;
      margin: 15px;
  }
  .col-con-left-tital-main{
    float: left;
    font-size: 20px;
    font-family: "微软雅黑 ";
    font-weight: bold;
    line-height: 24px;
  }
    .col-con-left-tital-min{
      font-family: "微软雅黑 ";
    float: right;
      font-size: 14px;
      color: #888888;
      line-height: 24px;
      margin-right: 30px;
  }
  .col-con-right{
        float: right;
      width: 585px;
        margin-left: 15px;
    background: #ffffff;
     padding: 5px;
  }
  .col-con-tital-tiao{
    float: left;
        border-style: none;
    width: 5px;
    height: 24px;
    margin-right: 8px;
  }
  .col-con-li-title{
    width: 450px;
    float: left;
        overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 20px;
    color: #333333;
  }
  .col-con-li-title-r{
    float: right;
  }
  .col-com-li-time{
    font-size: 14px;
    color:#888888;
    margin-bottom: 10px;
  }
  .col-con-ser-img {
    display: flex;
    /*background: #ffffff;*/
    /*height: 200px;*/
  }
  .col-con-ser-img img{
    width: 210px;
    height: 112px;
    margin: 15px;
  }
  .col-yqlj img{
    margin: 20px 0px 20px 45px;
    width: 240px;
    height: 95px;
  }
  .banner_dh{
  width: 100%;
  /*height: 650px;*/
  min-width: 1200px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
  .remy_item {
  width: calc(25% - 20px);
  height: auto;
  min-height: 200px;
  margin: 10px;
  position: relative;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  line-height: 1.6;
  padding: 20px 0;
  box-sizing: border-box;
  float: left;
}
  .remy_item:hover .pubimg1s{
    transform: rotateY(360deg); /* 旋转360度 */
  }
  .icon {
  transition: transform 0.5s ease; /* 动画时间和缓动效果 */
}
  .remy_item:nth-of-type(1) {
    background: #27a130;
    background: linear-gradient(135deg, #007cc8 0%, #05b3b4 100%);
}
  .remy_item:nth-of-type(2) {
    background: #e77c20;
    background: linear-gradient(135deg, #007cc8 0%, #05b3b4 100%);
}
  .remy_item:nth-of-type(3) {
    background: #0079c4;
    background: linear-gradient(135deg, #007cc8 0%, #05b3b4 100%);
}
  .remy_item:nth-of-type(4) {
    background: #6d38ab;
    background: linear-gradient(135deg, #007cc8 0%, #05b3b4 100%);
}
  .remy_item:nth-of-type(5) {
    background: #eeb32d;
    background: linear-gradient(135deg, #007cc8 0%, #05b3b4 100%);
}
  .remy_item .wimg {
    width: 50px;
    margin: 30px auto;}
  .remy_item .wnry {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;}
  .remy_item .wnre {
    font-size: 16px;
    margin: 10px 0 20px 0;}
  .remy_item .wnrs {
    border: 1px solid #ffffff;
    font-size: 14px;
    display: inline-block;
    padding: 0 30px;
    color: #ffffff;
}
  .pubimg1s {
    width: 100%;
    height: 100%;
    display: block;
    transition: all 1s;
}
  .Syleader_item {
    width: 147px;
    float: left;
    line-height: 2;
    text-align: center;
    padding: 0 50px;
}
  .Syleader_item .dimg {
    width: 65px;
    margin: 0 auto;
}
  .Syleader_item .dnr1 {
    font-size: 24px;
    color: #333333;
    font-weight: bold;
    margin: 25px 0;
}
  .Syleader_item .dnr2 {
    font-size: 14px;
    color: #555555;
}
  @media (max-width: 767px) {
  .slg_title1 {
    text-align: center;
    font-size: 1.8rem;
  }

  .slg_title2 {
    text-align: center;
    font-size: 1.2rem;
  }

  .col-tital-main {
    font-size: 1.8rem;
  }

  .remy_item, .Syleader_item {
    width: calc(100% - 20px);
  }
    .Syleader_item {
    line-height: 2;
    text-align: center;
    padding: 10px 5px;
}
    .hidden1{
      display: none;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/HomePhone.vue